import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from 'react';

const Token = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState<string | undefined>(undefined);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const next = await getAccessTokenSilently();
      if (!cancelled) setToken(next);
    })();
    return () => {
      cancelled = true;
    };
  }, [getAccessTokenSilently]);

  const copyToClipboard = async (textToCopy: string) => {
    // Technically should be using a useEffect for this, but this is just for
    // debugging so :)
    try {
      await navigator.clipboard.writeText(textToCopy);
      console.log('Text copied to clipboard successfully.');
      setCopied(true);
    } catch (error) {
      console.error('Failed to copy text to clipboard:', error);
    }
  };

  return (
    <>
      {token ? (
        <>
          <Paper
            elevation={2}
            sx={{ width: '100%', overflowWrap: 'anywhere', padding: '8px', margin: '4px' }}
          >
            {token}
          </Paper>
          <Button sx={{ margin: '4px' }} variant="outlined" onClick={() => copyToClipboard(token)}>
            {copied ? <span>Copied!</span> : <span>Copy to clipboard</span>}
          </Button>
        </>
      ) : (
        <div>...</div>
      )}
    </>
  );
};

export default Token;
